export const DEACTIVATE_FEATURE_START = 'DEACTIVATE_FEATURE_START';
export const DEACTIVATE_FEATURE_SUCCESS =
  'DEACTIVATE_FEATURE_SUCCESS';
export const DEACTIVATE_FEATURE_ERROR = 'DEACTIVATE_FEATURE_ERROR';
